<app-topnav></app-topnav>

  <!-- HEADER -->
  <ng-container>
  <header id="header-home">
        <div id="header-inner">
          <img class="blob-blue mobile" src="assets/img/header/header_mobile_blob_blue.svg" />
          <img class="blob-blue desktop" src="assets/img/header/header_blob_blue.svg" />

            <div class="container">
                <div class="row">
                    <div class="col col-6-md offset-lg-1 offset-xl-2">
                        <div class="slides-texts" *ngFor="let slideX of listeSlides; let index = index">
                            <div class="slides-text" [ngClass]="{'active' : selectedSlide === index}">
                                <h1 *ngIf="currentLang ==='fr'">
                                    <span [innerHtml]="slideX.titreFR"></span>
                                    <span [innerHtml]="slideX.sub1FR"></span>
                                    <span [innerHtml]="slideX.sub2FR"></span>
                                </h1>
                                <h1 *ngIf="currentLang ==='en'">
                                    <span [innerHtml]="slideX.titreEN"></span>
                                    <span [innerHtml]="slideX.sub1EN"></span>
                                    <span [innerHtml]="slideX.sub2EN"></span>
                                </h1>
                            </div>
                        </div>

                        <div class="slides-links" *ngFor="let slideX of listeSlides; let index = index">
                            <a class="cta slides-link" [ngClass]="{'active' : selectedSlide === index}" [routerLink]="slideX.route">{{ 'accueil.enSavoirPlus' | translate }} <i class="fa fa-arrow-right"></i></a>
                        </div>

                        <ul class="slides-nav">
                            <ng-container *ngFor="let slideX of listeSlides; let first = first; let index = index">
                            <li class="slides-nav-link" [ngClass]="{'active' : selectedSlide === index}"><a href="" (click)="onClickNews($event, index)">{{index + 1}}</a></li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </div>

            <img class="blob-green desktop" src="assets/img/header/header_blob_green.svg" />
            <img class="blob-orange-right desktop" src="assets/img/header/header_blob_orange_right.svg" />

            <div class="slides-images" *ngFor="let slideX of listeSlides; let index = index">
                <ng-container *ngIf="!slideX.lienWeb"><img class="slides-image" [ngClass]="{'active' : selectedSlide === index}" src="{{slideX.image}}" /></ng-container>
                <ng-container *ngIf="slideX.lienWeb"><a href="{{slideX.lienWeb}}" target="_blank"><img class="slides-image" [ngClass]="{'active' : selectedSlide === index}" src="{{slideX.image}}" /></a></ng-container>
            </div>

            <img class="bg-bottom mobile" src="assets/img/header/header_mobile_bottom.svg" />
            <img class="bg-bottom desktop" src="assets/img/header/header_bottom.svg" />
        </div>

      <img class="blob-purple-left desktop" src="assets/img/header/header_blob_purple_left.svg" />
      <img class="blob-green-left desktop" src="assets/img/header/header_blob_green_left.svg" />

      <img class="blob-white blob-white-1" src="assets/img/blobs/blob_white.svg" />
      <img class="blob-white blob-white-3" src="assets/img/blobs/blob_white.svg" />
      <img class="blob-white blob-white-4" src="assets/img/blobs/blob_white.svg" />
      <img class="blob-white blob-white-5" src="assets/img/blobs/blob_white.svg" />
  </header>
  </ng-container>
  <!-- end HEADER -->


    <!-- SECTION - students -->
    <section id="section-students">
        <img class="students-bg desktop" src="assets/img/accueil/section_students_bg.png" alt="[Background]">
        <div id="section-students-inner">
            <div class="container-fluid">
                <div class="row">
                    <div class="col col-12">
                        <h2 class="section-title" [innerHTML]="'accueil.studentsSection.title' | translate"></h2>
                        <p>{{ 'accueil.studentsSection.content' | translate }}</p>
                    </div>
                    <div class="col col-12">
                        <img data-animated="300" src="assets/img/accueil/section_students_children.png" alt="[Students]" />
                    </div>
                </div>
            </div>
        </div>

        <img data-animated="100" class="blob-white blob-white-1" src="assets/img/blobs/blob_white.svg" alt="[Decoration]" />
        <img data-animated="200" class="blob-white blob-white-2" src="assets/img/blobs/blob_white.svg" alt="[Decoration]" />
    </section>
    <!-- end SECTION - students -->

   <!-- SECTION - pedagogie -->
   <section id="section-pedagogie">
    <img class="blob-blue-top" src="assets/img/accueil/pedagogie_mobile_blob_blue_top.svg" />

    <div id="section-pedagogie-inner">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-12">
                    <h2 class="section-title" [innerHTML]="'accueil.pedagogieSection.title' | translate"></h2>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col col-12 col-md-6">
                    <img data-animated-left="300" class="blob-purple-top" src="assets/img/accueil/pedagogie_mobile_blob_purple_top.svg" />
                    <img data-animated="500" class="blob-green-top" src="assets/img/accueil/pedagogie_mobile_blob_green.svg" />
                    <img data-animated="700" class="blob-white-school" src="assets/img/blobs/blob_white_school.svg" />
                    <img data-animated="800" class="blob-white-speechbubble" src="assets/img/blobs/blob_white_speechbubble.svg" />
                    <img data-animated="800" class="blob-white-agenda" src="assets/img/blobs/blob_white_agenda.svg" />
                </div>

                <div class="col col-12 col-md-4 offset-md-1 offset-lg-0">
                    <h3 data-animated="300" [innerHTML]="'accueil.pedagogieSection.content.pourEleve.title' | translate"></h3>

                    <p data-animated="400">{{ 'accueil.pedagogieSection.content.pourEleve.content' | translate }}</p>
                </div>

                <img data-animated="500" class="blob-white blob-white-1" src="assets/img/blobs/blob_white.svg" />
            </div>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col col-12 col-md-6 order-md-2 offset-lg-0">
                    <img data-animated-right="300" class="blob-orange-large" src="assets/img/accueil/pedagogie_mobile_blob_orange.svg" />
                    <img data-animated="500" class="blob-blue-small" src="assets/img/accueil/pedagogie_mobile_blob_blue_small.svg" />
                    <img data-animated="700" class="blob-white-envelope" src="assets/img/blobs/blob_white_envelope.svg" />
                    <img data-animated="800" class="blob-white-prize" src="assets/img/blobs/blob_white_prize.svg" />
                    <img data-animated="800" class="blob-white-globe" src="assets/img/blobs/blob_white_globe.svg" />
                </div>

                <div class="col col-12 col-md-4 order-md-1 offset-md-1">
                    <h3 data-animated="300" [innerHTML]="'accueil.pedagogieSection.content.pourParent.title' | translate"></h3>

                    <p data-animated="400">{{ 'accueil.pedagogieSection.content.pourParent.content' | translate }}</p>
                </div>
            </div>
            
            <img data-animated="500" class="blob-white blob-white-2" src="assets/img/blobs/blob_white.svg" />
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col col-12 col-md-6">
                    <img data-animated-left="300" class="blob-bluegreen" src="assets/img/accueil/pedagogie_mobile_blob_bluegreen.svg" />
                    <img data-animated="500" class="blob-orange-small" src="assets/img/accueil/pedagogie_mobile_blob_orange_small.svg" />
                    <img data-animated="700" class="blob-white-switches" src="assets/img/blobs/blob_white_switches.svg" />
                    <img data-animated="800" class="blob-white-mobile" src="assets/img/blobs/blob_white_mobile.svg" />
                    <img data-animated="800" class="blob-white-document" src="assets/img/blobs/blob_white_document.svg" />
                </div>

                <div class="col col-12 col-md-4 offset-md-1 offset-lg-0">
                    <h3 data-animated="300" [innerHTML]="'accueil.pedagogieSection.content.pourEnseignant.title' | translate"></h3>

                    <p data-animated="400">{{ 'accueil.pedagogieSection.content.pourEnseignant.content' | translate }}</p>
                </div>
            </div>

            <img data-animated="500" class="blob-white blob-white-3" src="assets/img/blobs/blob_white.svg" />
        </div>
    </div>

    <img class="blob-blue-bottom" src="assets/img/accueil/pedagogie_mobile_blob_blue_bottom.svg" />
    <img class="bg-bottom" src="assets/img/accueil/pedagogie_bg_bottom.svg" />
</section>
<!-- end SECTION - pedagogie -->

<BR><BR>

<!-- SECTION - numbers -->
<section id="section-numbers">
    <img class="blob-white-bg mobile" data-animated="800" src="assets/img/accueil/numbers_mobile_blob_white.svg" />
    <img class="blob-white-bg desktop" data-animated="800" src="assets/img/accueil/numbers_blob_white.png" />

    <div id="section-numbers-inner">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-12">
                    <h2 data-animated="300" class="section-title" [innerHTML]="'accueil.numbersSection.title' | translate"></h2>

                    <p data-animated="300" class="section-texte">{{ 'accueil.numbersSection.content' | translate }}</p>

                </div>
                <div class="col col-12">
                    <img data-animated="300" class="blob-school" src="assets/img/accueil/numbers_school.png" alt="School">

                    <img data-animated="300" class="blob-teacher" src="assets/img/accueil/numbers_teacher.png" alt="Teacher">

                    <img data-animated="300" class="blob-studying" src="assets/img/accueil/numbers_studying.png" alt="Studying">

                    <img data-animated="300" class="blob-students" src="assets/img/accueil/numbers_students.png" alt="Students">

                    <!-- Blobs -->
                    <img data-animated-left="500" class="blob-purple-small" src="assets/img/accueil/numbers_mobile_blob_purple_small.svg" />
                    
                    <div data-animated="600" class="blob-blue">
                        <img src="assets/img/accueil/numbers_mobile_blob_blue.svg" />
                        <div class="content">
                            <h3>{{ 'accueil.numbersSection.numbers.ecoles.title' | translate }}</h3>
                            <p>{{ 'accueil.numbersSection.numbers.ecoles.content' | translate }}</p>
                        </div>
                    </div>

                    <img data-animated-right="400" class="blob-orange-small" src="assets/img/accueil/numbers_mobile_blob_orange_small.svg" />

                    <div data-animated="500" class="blob-green">
                        <img src="assets/img/accueil/numbers_mobile_blob_green.svg" />
                        <div class="content">
                                <h3>{{ 'accueil.numbersSection.numbers.connections.title' | translate }}</h3>
                                <p>{{ 'accueil.numbersSection.numbers.connections.content' | translate }}</p>
                        </div>
                    </div>

                    <img data-animated-left="400" class="blob-bluegreen" src="assets/img/accueil/numbers_mobile_blob_bluegreen.svg" />

                    <div data-animated="500" class="blob-purple">
                        <img src="assets/img/accueil/numbers_mobile_blob_purple.svg" />
                        <div class="content">
                                <h3>{{ 'accueil.numbersSection.numbers.eleves.title' | translate }}</h3>
                                <p>{{ 'accueil.numbersSection.numbers.eleves.content' | translate }}</p>
                        </div>
                    </div>

                    <img data-animated-right="400" class="blob-green-small" src="assets/img/accueil/numbers_mobile_blob_green_small.svg" />

                    <div data-animated="500" class="blob-orange">
                        <img src="assets/img/accueil/numbers_mobile_blob_orange.svg" />
                        <div class="content">
                                <h3>{{ 'accueil.numbersSection.numbers.assistance.title' | translate }}</h3>
                                <p>{{ 'accueil.numbersSection.numbers.assistance.content' | translate }}</p>
                        </div>
                    </div>

                    <!-- White Blobs -->
                    <img data-animated="200" class="blob-white blob-white-1" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="300" class="blob-white blob-white-2" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="200" class="blob-white blob-white-3" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="300" class="blob-white blob-white-4" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="200" class="blob-white blob-white-5" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="400" class="blob-white blob-white-6" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="200" class="blob-white blob-white-7" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="300" class="blob-white blob-white-8" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="200" class="blob-white blob-white-9" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="400" class="blob-white blob-white-10" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="200" class="blob-white blob-white-11" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="300" class="blob-white blob-white-12" src="assets/img/blobs/blob_white.svg" />
                    <img data-animated="200" class="blob-white blob-white-13" src="assets/img/blobs/blob_white.svg" />
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end SECTION - numbers -->

<app-temoignages></app-temoignages>

<app-news-slide></app-news-slide>

<app-footer></app-footer>
